<script>
  export let chosenVehicleType,
    chosenEnvClass,
    distance,
    fuelPrice,
    load,
    fuelConsumption,
    direction1Emission,
    direction2Emission,
    direction1EmissionTonDistance,
    direction2EmissionTonDistance,
    specificEmission,
    litersPer100KmDirection1,
    litersPer100KmDirection2,
    litersPerDistanceDirection1,
    litersPerDistanceDirection2,
    eurosDirection1,
    eurosDirection2,
    centPerTonPerKmDirection1,
    centPerTonPerKmDirection2,
    centPerTonPerKm,
    centPerTon

  const shareOfMax = (load) => load / chosenVehicleType.fullLoad

  const vehicleMassAndLoad = (load) => chosenVehicleType.vehicleMass + load

  const emissionRelationToLoad = (share) =>
    share * chosenEnvClass.carbon.full +
    (1 - share) * chosenEnvClass.carbon.empty

  const fuelRelationToLoad = (share) =>
    share * chosenEnvClass.fuelConsumption.full +
    (1 - share) * chosenEnvClass.fuelConsumption.empty

  const getLipastoConsumption = (load) => {
    const fuelRTL = fuelRelationToLoad(shareOfMax(load))
    return fuelRTL
  }

  const countGCO2Ekv = (load) => {
    const emissionRTL = emissionRelationToLoad(shareOfMax(load))
    const gCO2Ekv = distance * emissionRTL
    return gCO2Ekv
  }

  const countKgCO2Ekv = (load) => {
    const KgCO2Ekv = countGCO2Ekv(load) * Math.pow(10, -3)
    return KgCO2Ekv
  }

  const countGCO2EkvTonKm = (load) => {
    const gCO2Ekv = countGCO2Ekv(load)
    const gCO2EkvTonKm =
      gCO2Ekv / (chosenVehicleType.vehicleMass + load) / distance
    return gCO2EkvTonKm
  }

  const countSpecificEmission = () => {
    const specEmission =
      (vehicleMassAndLoad(load.direction1) * direction1EmissionTonDistance +
        vehicleMassAndLoad(load.direction2) * direction2EmissionTonDistance) /
      (vehicleMassAndLoad(load.direction1) +
        vehicleMassAndLoad(load.direction2))
    return specEmission
  }

  const countLitersPer100km = (load, fuelConsumption) => {
    const fuelCons =
      fuelConsumption > 0 ? fuelConsumption : getLipastoConsumption(load)
    return fuelCons
  }

  const countLiterPerDistance = (load, fuelConsumption) => {
    const litersPerDistance = fuelConsumption
      ? (fuelConsumption / 100) * distance
      : (getLipastoConsumption(load) / 100) * distance
    return litersPerDistance
  }

  const countEuros = (liters) => liters * fuelPrice

  const countCentPerTonPerKm = (liters, load) => {
    const centTonKm =
      ((liters * fuelPrice) / vehicleMassAndLoad(load) / distance) * 100
    return centTonKm
  }

  const countTotalCentPerTonPerKm = () => {
    const totalCentPerTonPerKm =
      (vehicleMassAndLoad(load.direction1) * centPerTonPerKmDirection1 +
        vehicleMassAndLoad(load.direction2) * centPerTonPerKmDirection2) /
      (vehicleMassAndLoad(load.direction1) +
        vehicleMassAndLoad(load.direction2))

    return totalCentPerTonPerKm
  }

  const countTotalCentPerTon = () => {
    const totalCentPerTon =
      ((vehicleMassAndLoad(load.direction1) *
        ((litersPerDistanceDirection1 * fuelPrice) /
          vehicleMassAndLoad(load.direction1)) +
        vehicleMassAndLoad(load.direction2) *
          ((litersPerDistanceDirection2 * fuelPrice) /
            vehicleMassAndLoad(load.direction2))) /
        (vehicleMassAndLoad(load.direction1) +
          vehicleMassAndLoad(load.direction2))) *
      100
    return totalCentPerTon
  }

  export const count = () => {
    load.direction1 =
      load.direction1 < chosenVehicleType.fullLoad
        ? load.direction1
        : chosenVehicleType.fullLoad
    load.direction2 =
      load.direction2 < chosenVehicleType.fullLoad
        ? load.direction2
        : chosenVehicleType.fullLoad

    direction1Emission = countKgCO2Ekv(Number(load.direction1))
    direction2Emission = countKgCO2Ekv(load.direction2)
    direction1EmissionTonDistance = countGCO2EkvTonKm(load.direction1)
    direction2EmissionTonDistance = countGCO2EkvTonKm(load.direction2)
    specificEmission = countSpecificEmission()
    litersPer100KmDirection1 = countLitersPer100km(
      load.direction1,
      fuelConsumption.direction1
    )
    litersPer100KmDirection2 = countLitersPer100km(
      load.direction2,
      fuelConsumption.direction2
    )
    litersPerDistanceDirection1 = countLiterPerDistance(
      load.direction1,
      fuelConsumption.direction1
    )
    litersPerDistanceDirection2 = countLiterPerDistance(
      load.direction2,
      fuelConsumption.direction2
    )
    eurosDirection1 = countEuros(litersPerDistanceDirection1)
    eurosDirection2 = countEuros(litersPerDistanceDirection2)
    centPerTonPerKmDirection1 = countCentPerTonPerKm(
      litersPerDistanceDirection1,
      load.direction1
    )
    centPerTonPerKmDirection2 = countCentPerTonPerKm(
      litersPerDistanceDirection2,
      load.direction2
    )
    centPerTonPerKm = countTotalCentPerTonPerKm()
    centPerTon = countTotalCentPerTon()
  }
</script>
